import { Component, OnInit } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';
import { CatalogosService } from 'src/app/services/catalogos.service';

@Component({
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {

  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio'
    }
  ];

  // Ocultar menús
  showMenu: boolean = false;

  // Tramites pendientes
  tview = false;
  tpLength: string;

  tramiteSearch: string = '';
  tramites: any[];
  dropdown: any;

  menuItems: any[] = [
    {
      label: 'Establecimientos',
      img: 'assets/img/DNM/UREP.png',
      routerLink: '/establecimientos',
      active: true
    },
    {
      label: 'Poderes',
      img: 'assets/img/DNM/UREP2.png',
      routerLink: '/poderes',
      active: true
    },
    {
      label: 'Contratos',
      img: 'assets/img/DNM/UREP3.png',
      routerLink: '/contratos',
      active: true
    },
    {
      label: 'Análisis de Laboratorio',
      img: 'assets/img/DNM/PF.png',
      routerLink: '/laboratorios',
      active: true
    },
    {
      label: 'farmacéuticos',
      img: 'assets/img/DNM/PF.png',
      routerLink: '/farmaceuticos',
      active: true
    },
    {
      label: 'Químicos',
      img: 'assets/img/DNM/NIPQ.png',
      routerLink: '/quimicos',
      active: true
    },
    {
      label: 'Veterinarios',
      img: 'assets/img/DNM/VAC.png',
      routerLink: '/veterinarios',
      active: true
    },
    {
      label: 'Dispositivos Médicos',
      img: 'assets/img/dispositivos/medicos.png',
      routerLink: '/dispositivos',
      active: true
    },
  ];

  constructor(private catalogoService: CatalogosService) {
  }

  ngOnInit(): void {
    const tp = localStorage.getItem('tp') ? localStorage.getItem('tp').toString() : '0';
    if (tp !== '0') {
      this.tpLength = tp;
      this.tview = true;
    }
  }

  searchTramite(dropdown) {
    this.dropdown = dropdown;
    this.catalogoService.searchTramite(this.tramiteSearch).subscribe(
      res => {
        this.tramites = res.map(t => {
          let tipo_especial = '';
          if (t.tipo_registro == 'POS-COS') tipo_especial = 'PRODUCTOS COSMÉTICOS';
          if (t.tipo_registro == 'POS-HIG') tipo_especial = 'PRODUCTOS HIGIÉNICOS';
          return {
            area: t.area,
            codigo_proceso: t.codigo_proceso,
            nombre_proceso: t.nombre_proceso,
            tipo: t.tipo,
            tipo_registro: t.tipo_registro,
            value: t.codigo_proceso,
            label: tipo_especial ? tipo_especial + ' - ' + t.nombre_proceso : t.tipo + ' - ' + t.nombre_proceso
          }
        }
        );
        this.dropdown.show();
      }
    );
  }

  onChange(event) {
    if (event.originalEvent.inputType) {
      this.tramiteSearch = event.value;
    } else {
      if (event.value !== null) {
        let url = location.protocol + '//' + location.host + '#/tramite/' + event.value;
        window.open(url, '_blank');
      }
    }
  }
}
